import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ReportService} from '../service/report.service';

@Component({
  selector: 'app-report-view',
  templateUrl: './report-view.component.html',
  styleUrls: ['./report-view.component.css']
})
export class ReportViewComponent implements OnInit {
  itemsPerPage = 10;
  currentPage = 1;
  regExp = '';
  public reportList: any = [];
  public noOfReports: any;
  public loading = true;
  constructor(private reportService: ReportService, private router: Router) {
    this.reportList = [];
  }

  ngOnInit() {
    console.log('Getting reports')
    this.reportService.getReportsByClientId().subscribe(data => {
      this.reportList = data.json();
      this.loading = false;
    });
  }

  pageChanged(event) {
    this.currentPage = event;
    console.log(event);
  }

  search() {
    console.log('' + this.regExp);
  }

  resend(id: any) {
    const payload = {}
    this.reportService.resend(id, payload).subscribe(data => {
      console.log('Resent')
    });
  }

}
